<template>
    <div v-if="config" class="w-full">
        <setting-card
            v-bind="binds"
            :hideMoreVert="true"
            :hidePrevious="true"
            @updateProfile="updateProfile()"
        >
            <Workflow :companyId="companyId" :config="config" />
        </setting-card>
    </div>
</template>

<script lang="ts">
import settingCard from "../SettingCard.vue";
import Workflow from "../../admin/Workflow.vue";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    components: {
        settingCard,
        Workflow,
    },
    emits: ["updateProfile"],
})
export class SettingWorkflow extends Vue {
    @Prop({ default: null }) config!: any;
    @Prop({ default: "" }) companyId: string;
    @Prop({ default: "" }) payActions: string;

    get binds() {
        return {
            title: "Workflow des factures",
            partnerName: "bobbee",
            text: "Définissez le workflow de validation des factures d'achats.",
            // logo: BobbeeImg
        };
    }

    updateProfile() {
        this.$emit("updateProfile");
    }
}

export default toNative(SettingWorkflow);
</script>
